export default __webpack_public_path__ + "static/media/business-model-innovation.b3c896ca.svg";